const removeEmptyStrForMapKey = function(dataMap){ // 删除属性key末尾的空格
    let newDataMap = {}, tempKey;
    for(let key in dataMap){
        tempKey = key.trim();
        newDataMap[tempKey] = dataMap[key];
    }
    return newDataMap
}
export default {
    getRotate(xy, xx){
        let rotate = Math.round(Math.atan2(xy, xx) * (180 / Math.PI));
        if(rotate < 0){
            rotate = 360 + rotate;
        }
       return rotate;
    },
    getDropShadow(node){
        /**
         * 文字投影
         * Clr: 颜色，Opct: 透明度，lagl: 角度, Dstn: 距离，扩展：Ckmt， Nose: 大小
         */
        if(!node.layer.adjustments.objectEffects || !node.layer.adjustments.objectEffects.data){
            return null;
        }
        let {Opct, Clr, lagl, Dstn, Ckmt, blur} = removeEmptyStrForMapKey(node.layer.adjustments.objectEffects.data.DrSh);
        let {Rd, Grn, Bl} = removeEmptyStrForMapKey(Clr);
    },
    getTextBorder(node){
        /**
         * 文字描边
         * Opct: 透明度, Sz: 大小, Clr: 颜色
         */
        let objectEffects = node.layer.adjustments.objectEffects;
        if(!objectEffects || !objectEffects.data || !objectEffects.data.FrFX){
            return null;
        }
        let {Opct, Sz, Clr} = removeEmptyStrForMapKey(objectEffects.data.FrFX);
        let {Rd, Grn, Bl} = removeEmptyStrForMapKey(Clr);
        let opt = Opct ? parseFloat((Opct.value / 100).toFixed(2)) : 100;
        let rgba = `rgba(${parseInt(Rd)}, ${parseInt(Grn)}, ${parseInt(Bl)}, ${opt})`;
        return {
            borderWidth: Sz.value,
            color: `${parseInt(Rd)}, ${parseInt(Grn)}, ${parseInt(Bl)}`,
            opacity: Opct.value,
            value: `${Sz.value}px ${rgba}`
        }
    }
}